export default __webpack_public_path__ + "static/media/CarInteriorDetailing.211e3eb7.jpg";